/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const PercentageIcon = (props) => {
    let _calculatePercentage = (percentageFilled: any) => {
        return (1000 - (percentageFilled * 1.33))
    }
    return (
        <svg width="49" height="49" viewBox="0 0 49 49" xmlns="http://www.w3.org/2000/svg">
            <g strokeWidth="6" fill="none" fillRule="evenodd">
                <circle stroke="#F0F3F5" cx="24.5" cy="24.5" r="21.5" />
                <circle stroke="#F07662" strokeLinecap="round" strokeDasharray="1000" strokeDashoffset={_calculatePercentage(props.percentageFilled)} transform="rotate(-88 24.5 24.5)" cx="24.5" cy="24.5" r="21.5" />
            </g>
        </svg>

    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Percentage/Percentage.tsx